import HttpClient from "../helpers/client"
import { IResponse } from "../interfaces/response.interface"

export const GetStatesService = (country: string): Promise<IResponse<any>> => {
    return (new HttpClient()).get<IResponse<any>>('country/regions', { country })
}

export const GetCountriesService = (country?: string): Promise<IResponse<any>> => {
    return (new HttpClient()).get<IResponse<any>>('country', country? { country } : {})
}